import { createContext } from 'react';
import type { LibraryTitleInputProps } from './library-title-input.types';

const LibraryTitleAppearanceContext = createContext<NonNullable<LibraryTitleInputProps['appearance']>>('default');

export default LibraryTitleAppearanceContext;
